import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import GroupSubNav from "../../../components/layout/GroupSubNav";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import { ArrowUpRight } from "../../../components/svgs";
import TeamImg from "../../../assets/images/png/careerheader.webp";

const pills = ["Small teams", "Global products", "Visible impact"];

const CareerHeaderSection = ({ openRolesCount }) => {
  const handleScrollToOpenings = () => {
    document.querySelector("#roles")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      style={{ backgroundImage: "linear-gradient(#fff 0%, #f7f9ff 100%)" }}
    >
      <HeaderNavigation />
      <GroupSubNav />

      <div className="container mx-auto px-4 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-12 lg:gap-10">
          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                Careers at Utiva
              </p>

              <h1 className="text-primary text-4xl md:text-5xl lg:text-7xl font-poppins tracking-[-0.03em] leading-[1.05] font-black mb-7">
                Build work that moves{" "}
                <span className="text-default">people forward.</span>
              </h1>

              <p className="font-poppins text-lg md:text-xl text-gray leading-relaxed mb-9 max-w-xl">
                Join a small, ambitious team creating practical learning and
                workforce products used by people and companies around the
                world.
              </p>

              <div className="flex flex-wrap font-poppins items-center gap-5 md:gap-7 text-base md:text-lg mb-6">
                <button
                  type="button"
                  onClick={handleScrollToOpenings}
                  className="text-white bg-primary font-poppins custom-btn px-8 py-4 text-center rounded-xl inline-flex items-center font-bold shadow-course-feature focus:outline-none"
                >
                  View open roles
                  <span className="ml-2">↓</span>
                </button>
                <Link
                  to="/be-a-trainer"
                  className="text-primary border-2 border-primary font-poppins px-8 py-4 rounded-xl inline-flex items-center gap-2 font-bold hover:bg-primary hover:text-white transition-colors"
                >
                  Become a trainer
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </Link>
              </div>

              <div className="flex flex-wrap gap-3">
                {pills.map((pill) => (
                  <span
                    key={pill}
                    className="rounded-full border border-hire-line px-4 py-2 font-poppins text-sm font-bold text-default"
                  >
                    {pill}
                  </span>
                ))}
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <div
                className="relative rounded-3xl overflow-hidden shadow-course-feature-lg"
                style={{ minHeight: "580px" }}
              >
                <img
                  src={TeamImg}
                  alt="The real Utiva team"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: "40%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,71,0.92))",
                  }}
                ></div>

                {typeof openRolesCount === "number" && openRolesCount > 0 && (
                  <div className="absolute top-5 right-5 z-10 w-20 h-20 rounded-full bg-secondary text-primary flex flex-col items-center justify-center shadow-course-feature">
                    <strong className="font-poppins text-2xl font-extrabold leading-none">
                      {openRolesCount}
                    </strong>
                    <span className="font-poppins text-[10px] font-bold text-center leading-tight">
                      open roles
                    </span>
                  </div>
                )}

                <div className="absolute z-10 bottom-6 left-6 right-6 border-l-4 border-secondary bg-primary w-fit backdrop-blur px-5 py-4 font-poppins">
                  <p className="text-secondary text-xs font-extrabold tracking-widest uppercase mb-1">
                    Real Utiva team
                  </p>
                  <strong className="text-white text-base font-extrabold">
                    Building from Africa for the world
                  </strong>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CareerHeaderSection;
